import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { CreatedUser, User } from '@models/swagger';
import { PostUserParams } from './service';

export enum PostUserActions {
  Failure = '[Application Utilities PostUser] Failure',
  Request = '[Application Utilities PostUser] Request',
  Success = '[Application Utilities PostUser] Success',
}

export const PostUserFailure = createAction(PostUserActions.Failure, props<{ error: HttpErrorResponse }>());

export const PostUserRequest = createAction(
  PostUserActions.Request,
  props<{ body: User; parameters?: PostUserParams }>()
);

export const PostUserSuccess = createAction(PostUserActions.Success, props<{ data: CreatedUser }>());
